'use strict';

class DistanceControllerService {
    constructor() {

    }

    addNewDistanceFromController(payload) {
        wv.sendTextMessage(getTextMessage(text_addRubberBandDistancePoint, payload.id, payload.controllerName, payload.point.x, payload.point.y,
            payload.point.z, payload.branchId, payload.modelId));
    }

    updateSelectedDistancePoint(payload) {
        wv.sendTextMessage(getTextMessage(text_updateSelectedDistancePoint, payload.userId, payload.controllerName,
            payload.point.x, payload.point.y, payload.point.z, payload.bodyName, payload.property, payload.index));
    }

    deleteLastDistancePoint(payload) {
        wv.sendTextMessage(getTextMessage(text_deleteLastDistancePoint, payload.userId, payload.controllerName));
    }
}

export default DistanceControllerService;